module.exports = __webpack_public_path__ + "img/base.204709a2.png";